import axios from "axios"

let API_URL = "https://api.anamnesis-back.call4.life/v1" // Initialize API_URL
// let API_URL = "http://localhost:3001/api/v1" // Initialize development API_URL

// PUBLIC ROUTERS
const $publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

$publicApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log(error.message)
    throw error
  },
)

// PRIVATE ROUTERS
const $privateApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
})

$privateApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  const store = JSON.parse(localStorage.getItem("app"))

  config.params = { ...config.params, lang: store.state.meta.lang }

  return config
})

$privateApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const response = await axios.post(`${API_URL}/auth/refresh`, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        })

        localStorage.setItem("token", response.data.access_token)
        return $privateApi.request(originalRequest)
      } catch (e) {
        console.log("НЕ АВТОРИЗОВАН")
        console.log(e.message)
        location.href = "/"
      }
    }

    throw error
  },
)

export { $privateApi, $publicApi }
